export enum CollapseStateEnum {
  Expended = 'expended',
  Collapsed = 'collapsed',
}
